export default __webpack_public_path__ + "static/media/menu-footer-bg.0a034ebb.png";